/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TableCell } from '@mui/material';
import * as actionsVeiculos from '../../../store/veiculo/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsVeiculos from '../../../store/veiculo/reducer';
import * as Role from '../../../constants/role';
import { getMaxColumnLength } from '../../../utils';
import { TableWidgetV2 } from '../../../components/v2';
import HistoricoVeiculoModal from './HistoricoVeiculoModal';
import {
  formatHistoricoData,
  formatHistoricoValor,
  getHistoricoValor,
  getTipoHistoricoLabel,
  isHistoricoReadOnly,
  ordernarPorDataHistorico,
} from './helpers';

const HistoricoTab = ({
  idVeiculo,
  historico,
  userRole,
  deleteHistoricoVeiculo,
  initialHistoricoId,
}) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [historicoVeiculoId, setHistoricoVeiculoId] = useState(null);

  const isAdmin = () => Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;

  const renderRows = (h) => (
    <>
      <TableCell>{formatHistoricoData(h)}</TableCell>
      <TableCell>{getTipoHistoricoLabel(h)}</TableCell>
      <TableCell align="right">{formatHistoricoValor(getHistoricoValor(h))}</TableCell>
      <TableCell size="medium" title={h.observacao}>
        {getMaxColumnLength(h.observacao)}
      </TableCell>
    </>
  );

  const onDelete = (rowId) => {
    deleteHistoricoVeiculo(rowId, () => {
      setRows([...rows.filter((s) => s.id !== rowId)]);
    });
  };

  const onEdit = (rowId) => {
    setHistoricoVeiculoId(rowId);
    setOpen(true);
  };

  const onAdd = () => {
    setHistoricoVeiculoId(null);
    setOpen(true);
  };

  const afterSave = (data) => {
    setRows([...rows.filter((s) => s.id !== data.id), data].sort(ordernarPorDataHistorico));
  };

  useEffect(() => {
    setRows(historico || []);
  }, [historico]);

  useEffect(() => {
    if (!initialHistoricoId) {
      setHistoricoVeiculoId(null);
      setOpen(false);
      return;
    }
    setHistoricoVeiculoId(initialHistoricoId);
    setOpen(true);
  }, [initialHistoricoId]);

  return (
    <>
      <TableWidgetV2
        rows={rows}
        titles={['Data / Ano', 'Tipo', 'Valor', 'Descrição']}
        deleteMessage="A informação será removido e não poderá ser mais recuperado."
        renderRows={renderRows}
        onEdit={onEdit}
        onView={onEdit}
        showView
        showEditRow={(row) => !isHistoricoReadOnly(row)}
        showViewRow={isHistoricoReadOnly}
        showDeleteRow={(row) => !isHistoricoReadOnly(row)}
        onDelete={onDelete}
        onAdd={onAdd}
        hasRowActions={isAdmin()}
        hasAdd={isAdmin()}
      />
      <HistoricoVeiculoModal
        open={open}
        onClose={() => {
          setHistoricoVeiculoId(null);
          setOpen(false);
        }}
        idVeiculo={idVeiculo}
        id={historicoVeiculoId}
        historicoRows={rows}
        afterSave={afterSave}
      />
    </>
  );
};

HistoricoTab.propTypes = {
  idVeiculo: PropTypes.string,
  historico: PropTypes.array,
  userRole: PropTypes.string,
  deleteHistoricoVeiculo: PropTypes.func.isRequired,
  initialHistoricoId: PropTypes.string,
};

HistoricoTab.defaultProps = {
  initialHistoricoId: null,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsVeiculos,
  ...selectorsVeiculos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoTab);
